export const FETCH_PLACE = "place/FETCH_PLACE";
export const FETCH_PLACE_SUCCESS = "place/FETCH_PLACE_SUCCESS";
export const FETCH_PLACES = "place/FETCH_PLACES";
export const FETCH_PLACES_SUCCESS = "place/FETCH_PLACES_SUCCESS";
export const SAVE_PLACE = "place/SAVE_PLACE";
export const SAVE_PLACE_SUCCESS = "place/SAVE_PLACE_SUCCESS";
export const UPDATE_PLACE = "place/UPDATE_PLACE";
export const UPDATE_PLACE_SUCCESS = "place/UPDATE_PLACE_SUCCESS";
export const DELETE_PLACE = "place/DELETE_PLACE";
export const DELETE_PLACE_SUCCESS = "place/DELETE_PLACE_SUCCESS";
